/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import StepNumber from "./StepNumber.vue";
import "./StepWrapper.scss";

export default function StepWrapper({
  stepNumber = 1,
  headerText,
  withGap = false,
  hasError = false,
  borderless = false,
  children,
  slots,
  ...restProps
}: any) {
  const { isArtworkUploaded, ...domProps } = restProps;
  return (
    <div
      {...domProps}
      className={cn("step-wrapper", {
        "step-wrapper--with-gap": withGap,
        "step-wrapper--with-error": hasError,
        "step-wrapper--borderless": borderless
      })}
    >
      <div className="step-wrapper__header">
        <div className="step-wrapper__header-left">
          {!borderless ? (
            <StepNumber
              compact={borderless}
              stepNumber={stepNumber}
              content={headerText}
              data-testid="step-number"
            />
          ) : null}
          {slots?.["header-badge"]?.()}
        </div>
        {slots?.["step-number-content"]?.()}
      </div>
      {children}
    </div>
  );
}
